import { CommonValuableConceptResponse, ValuableType } from '@/api/resources/common/valuable-concepts/valuable-concept.dto'
import { commonValuableConceptsService } from '@/api/resources/common/valuable-concepts/valuable-concepts.service'
import { initialValuableConceptsModalBasicRelationshipsState, ValuableConceptsModalBasicRelationshipsState } from '@/modules/configurationModule/detail/automation/valuable-concepts/components/valuable-concepts-modal-relationships/valuable-concepts-modal-relationships.model'
import { valuableConceptRelationshipConfigurationServices } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts-relationship.service'
import { ConfigurationAutomaticOntologyValuableConceptCreateRequest, ConfigurationAutomaticOntologyValuableConceptResponse, ConfigurationOntologyForAutomaticValuableConceptResponse } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts.dto'
import ConfigurationRelationships from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { EntityIdentifiersRequest } from '@/shared/models/http/http.model'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class ValuableConceptsModalRelationships extends Vue {
    @Prop() readonly selectedRow!: ConfigurationOntologyForAutomaticValuableConceptResponse

    state: ValuableConceptsModalBasicRelationshipsState
    constructor() {
        super()
        this.state = initialValuableConceptsModalBasicRelationshipsState()
    }

    async mounted() {
        await this._loadValuableConceptsRelationship()
    }

    async createRelationship(valuableConcept: CommonValuableConceptResponse): Promise<void> {
        const request: ConfigurationAutomaticOntologyValuableConceptCreateRequest = {
            ontologyForAutomaticValuableConceptId: this.selectedRow.id,
            valuableConceptId: valuableConcept.id
        }
        const [err] = await this.$_toCall(valuableConceptRelationshipConfigurationServices.createValuableConcept(this.selectedRow?.laboratory.labId, request))
        if (err) {
            this.$_showErrorModalFromErrorResponse(err)
            return
        }
        this.$_showToastSuccess(this.$t('configuration.toastMessages.automationValuableConceptsCreated') as string)

        await this._loadValuableConceptsRelationship()
    }

    async deleteRelationship(relationId: ConfigurationAutomaticOntologyValuableConceptResponse): Promise<void> {
        const valuableConceptsToDelete: EntityIdentifiersRequest = {
            entityIdentifiers: [relationId.id]
        }
        const [err] = await this.$_toCall(valuableConceptRelationshipConfigurationServices.deleteValuableConcept(this.selectedRow.laboratory.labId, valuableConceptsToDelete))
        if (err) {
            this.$_showErrorModalFromErrorResponse(err)
            return
        }
        this.$_showToastSuccess(this.$t('configuration.toastMessages.automationValuableConceptsDeleted') as string)

        await this._loadValuableConceptsRelationship()
    }

    // TODO An endpoint is needed to obtain all evaluable concepts
    // TODO Right now is fixing to get only the URV type valuable concepts
    async getValuableConcepts(): Promise<CommonValuableConceptResponse[]> {
        const [err, response] = await this.$_toCall(commonValuableConceptsService.getAllActiveValuableByLaboratory(this.selectedRow?.laboratory.labId, ValuableType.URV))
        if (err) {
            return []
        }
        return response
    }

    private async _loadValuableConceptsRelationship(): Promise<void> {
        this.state.valuableConcepts = await this._getValuablesConceptsRelationships()
    }

    private async _getValuablesConceptsRelationships(): Promise<ConfigurationAutomaticOntologyValuableConceptResponse[]> {
        const filterModel = {
            'ontologyForAutomaticValuableConcept.id': GridUtils.getNumberFilterModel('equals', this.selectedRow.id)
        }
        const [err, response] = await this.$_toCall(valuableConceptRelationshipConfigurationServices.getValuableConcepts(filterModel, {}, this.selectedRow.laboratory.labId))
        if (err) {
            return []
        }
        return response?.content
    }
}
